var exports = {
  "x6": "DiscoveryButton.module__button___TU9MWk",
  "td": "DiscoveryButton.module__iconText___TU9MWk",
  "yF": "DiscoveryButton.module__iconTextSelected___TU9MWk",
};

module.exports = exports;
